import { Content } from 'src/contexts/ContentContext';
import { PosFormField } from 'src/core/POS/PosFormField';
import { PosSelect } from 'src/core/POS/PosSelect';
import { ContentId } from 'src/utils/constants/contentId';

export type StateSelectProps = {
  value: string;
  options: Record<string, string>;
  onChange: (value: string) => void;
  loading?: boolean;
  disabled?: boolean;
};

export function StateSelect({
  value,
  options,
  onChange,
  loading,
  disabled,
}: StateSelectProps) {
  return (
    <PosFormField label={<Content id={ContentId.State} />}>
      <PosSelect
        style={{ width: '100%' }}
        valueOptionsContent={options}
        value={value}
        onChange={onChange}
        placeholderText={ContentId.SelectStateProvince}
        loading={loading}
        disabled={disabled}
        searchable
        enableEmptySelection
      />
    </PosFormField>
  );
}
